import React, { createContext, useContext, useState, useEffect } from 'react';
import { getLatestConversation } from '../services/aiFeatures';

const ChatContext = createContext();

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};

export const ChatProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [conversationId, setConversationId] = useState(null);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);

  const loadLatestConversation = async (userId) => {
    if (userId && messages.length === 0) {
      setIsLoadingHistory(true);
      try {
        const latestConversation = await getLatestConversation(userId);
        if (latestConversation && latestConversation.messages.length > 0) {
          setMessages(latestConversation.messages);
          setConversationId(latestConversation.conversationId);
        }
      } catch (error) {
        console.error("Error loading conversation history:", error);
      } finally {
        setIsLoadingHistory(false);
      }
    }
  };

  const addMessage = (message) => {
    setMessages(prev => [...prev, message]);
  };

  const clearMessages = () => {
    setMessages([]);
    setConversationId(null);
  };

  const value = {
    isOpen,
    setIsOpen,
    messages,
    setMessages,
    conversationId,
    setConversationId,
    isLoadingHistory,
    loadLatestConversation,
    addMessage,
    clearMessages
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
}; 